import React from "react";
import AllocationRuleFormModal from "@features/admin/finance/allocation-rule/components/AllocationRuleFormModal";
import { FinanceAllocationRule } from "@features/admin/finance/allocation-rule/types/financeAllocationRule";

const UpdateAllocationRuleModal: React.FC<{
    show: boolean;
    onHide: () => void;
    rule: FinanceAllocationRule | null;
    onSuccess?: () => void | Promise<void>;
}> = ({ show, onHide, rule, onSuccess }) => {
    if (!rule) return null;
    return (
        <AllocationRuleFormModal
            show={show}
            onHide={onHide}
            rule={rule}
            onSaved={onSuccess}
            testId="update-allocation-rule-modal"
        />
    );
};

export default UpdateAllocationRuleModal;
